import React, {useContext, useEffect, useState} from 'react';
import {Popover, Select, Button, message} from 'antd';
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {RoleContext} from "../../contexts/RoleContext";

const { Option } = Select;

const UserBan = ({record, imba_id}) => {
    const [period, setPeriod] = useState(0);
    const [visible, setVisible] = useState(false);

    const success = (text) => {
        message.success(text);
    };

    const onBan = (item) => {
        AxiosRequestWithImba('ban_user', {
            userId: record.id,
            ban_period: period,
            room_id: -1,
            ban_reason: 'admin ban',
            admin: localStorage.getItem('comet-user-id')
        }, imba_id).then((data) => {
            if (!data.error)
            {
                success('User successfully banned!')
                setVisible(false)
            }
        })
    }

    const handleVisibleChange = (visible) => {
        setVisible(visible)
    };

    const content = (
        <div>
            <Select placeholder="Select ban period" style={{ width: '100%' }} onChange={(value) => setPeriod(value)}>
                <Option value="0.5">30m</Option>
                <Option value="1">1h</Option>
                <Option value="24">24h</Option>
                <Option value="168">1 week</Option>
                <Option value="999999">forever</Option>
            </Select>
            <Button className={'m-1'} onClick={() => onBan(record)}>OK</Button>
        </div>
    );

    const {getRole} = useContext(RoleContext);
    const {setRole} = useContext(RoleContext);
    const role = getRole()


    if(role !='operator'){
    return (
        <Popover visible={visible} placement="topLeft" title={'Confirm ban'} content={content} trigger={'click'} onVisibleChange={handleVisibleChange}>
            <a className={'button'} id={`ban-${record.user_id}`}>ban user</a>
        </Popover>
    );
    }
    else{
        return (
            <>
            </>
        );
    }
};


export default UserBan;